import React from "react";
import Cover from "../../book/cover";
import { Translation } from "../../../../core/translate";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { getBooks } from "../../../../../redux/books/selectors";
import * as bookActions from "../../../../../redux/book/actions";
import { actions as uiLibraryActions } from "../../../../../redux/ui/library";
import { actions as routerActions } from "../../../../../redux/router";
import { connect } from "react-redux";
import { getCurrentRoute } from "../../../../../redux/router/selectors";
import { UnsafeHtml } from "../../../../components/mixins";
import {
  styledMedia,
  withAllMatches
} from "../../../../components/mediaquery/breakpoints";
import { quickSearchLicensedContent } from "./quicksearch";
import AccessibleSearchResults from "../../../../../components/accessability/accessibleSearchResults";

const ITEM_HEIGHT = 52;
const VISIBLE_ITEMS = 5;

const MainContainer = styled.div``;

const OuterList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: ${ITEM_HEIGHT * VISIBLE_ITEMS}px;
  width: 330px;

  ${styledMedia.medium`
    width: 280px;
  `}
  ${styledMedia.small`
    width: 100%;
  `}
`;

const ResultItem = styled.li`
  font-size: 1.5rem;
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
  white-space: nowrap;
  position: relative;
  height: ${ITEM_HEIGHT}px;
  line-height: ${ITEM_HEIGHT}px;

  button {
    height: 100%;
    width: 100%;
    background: none;
    border: 0;
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0 10px;
    position: relative;

    &:after {
      background-color: ${cloud.getShade(4)};
      content: "";
      height: 1px;
      width: calc(100% - 20px);
      position: absolute;
      bottom: 0;
      left: 10px;
      display: block;
    }

    &:hover,
    &:focus {
      background-color: ${props => props.theme.color.primary.getShade(1)};
    }

    & > span:last-child {
      margin-left: 11px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

const CoverContainer = styled.div`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2px;
`;

const ViewAllButton = styled.button`
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  width: 100%;
  height: 42px;
  line-height: 42px;
  font-size: 1.5rem;
  color: ${props => props.theme.color.primary.getShade(6)};
  position: relative;
`;

class PopoverContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      results: []
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const changedTerm = this.props.searchTerm !== nextProps.searchTerm;
    const changedType = this.props.searchType !== nextProps.searchType;
    const changedBooks = this.props.books !== nextProps.books;

    if (changedTerm || changedType || changedBooks) {
      // I tried some things with throttling, timeouts, etc, but the popover
      // starts jumping around for some reason I don't quite get yet
      this.setState({
        results: quickSearchLicensedContent(
          nextProps.books,
          nextProps.searchTerm,
          nextProps.searchType
        )
      });
    }
  }

  goToSearchPage = () => {
    const encodedTerm = encodeURIComponent(this.props.searchTerm);
    this.props.push("search", { q: encodedTerm });
  };

  mobileClick = () => {
    if (this.props.isSmall) {
      this.props.closePanel();
    }
  };

  render() {
    // Since this only searches licensed books,
    // disable on pages that aren't the main library tab to prevent confusion
    // This is enabled on mobile now. 1) it creates a blank screen otherwise 2) the context of a licensed book feels different in mobile

    const hidePopover =
      (this.state.results.length === 0 ||
        this.props.route.hash !== "#/" ||
        (this.props.searchTerm === "" && this.props.searchType === "")) &&
      !this.props.isSmall;

    if (hidePopover) {
      return null;
    }
    return (
      <MainContainer>
        <AccessibleSearchResults total={this.state.results.length} />
        <OuterList>
          {this.state.results.map(r => (
            <ResultItem key={r.isbn}>
              <button
                type="button"
                onClick={() => {
                  this.mobileClick(this.props.launchBook(r.isbn));
                }}
              >
                <CoverContainer>
                  <Cover
                    width={26}
                    height={32}
                    isbn={r.isbn}
                    borderRadius={2}
                    includeRetina={false}
                    bookTitle={r.title}
                    //  omit img alt text because book title is enough for a11y
                    altText=""
                  />
                </CoverContainer>
                <UnsafeHtml>{r.title}</UnsafeHtml>
              </button>
            </ResultItem>
          ))}
        </OuterList>
        {this.props.searchTerm && this.state.results.length > 0 && (
          <ViewAllButton
            onClick={() => {
              this.mobileClick(this.goToSearchPage());
            }}
          >
            <Translation id="header.search.view-all" />
          </ViewAllButton>
        )}
      </MainContainer>
    );
  }
}

const mapStateToProps = state => ({
  books: getBooks(state),
  route: getCurrentRoute(state)
});

const mapDispatchToProps = dispatch => ({
  launchBook: isbn =>
    dispatch(bookActions.launchLicensedBook(isbn, { context: "typeahead" })),
  closePanel: () => dispatch(uiLibraryActions.closePanel()),
  push: (dest, query) => dispatch(routerActions.push(dest, query))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAllMatches(PopoverContent));
